import React, { useState } from 'react'
import {
    Container,
    Content,
    Form,
    Alert,
    Button
} from './styles';
import { useAuth } from '../../contexts/AuthContexts';
import { Link } from 'react-router-dom';

export const ForgotPassword = () => {

    const [ registerEmail, setRegisterEmail ] = useState("")
    const { resetPassword } = useAuth();
    const [ error, setError ] = useState("");
    const [ message, setMessage ] = useState("");
    const [ loading, setLoading ] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setMessage('')
            setError("");
            setLoading(true);
            await resetPassword(registerEmail);
            setMessage('Checar seu e-mail para recuperação de senha')
        } catch {
            setError("Failed to Sign In");
        }

        setLoading(false);
    }
    return (
        <Container>
            <Content>
                <Form>
                    <h1>Recuperação de senha</h1>
                    { error && <Alert>{error}</Alert>}
                    { message && <Alert>{message}</Alert> }
                    <input
                        className="input" 
                        placeholder="Email"
                        onChange = {(event) => {
                            setRegisterEmail(event.target.value)
                        }}
                    />
                    <Button disabled={ loading } onClick={ handleSubmit }> Log In </Button>
                </Form>
                <div>
                    Já tem login? <Link to="/login">Retornar</Link>
                </div>
            </Content>
        </Container>
    )
}